import { billingItemTypeTag } from './tag';
import { makeCriteriaProvider } from './enhancers';
import BillingTypeFacetDetails from './BillingItemTypeFacetDetails';

export default {
  tag: billingItemTypeTag,
  makeCriteriaProvider,
  DetailsControl: BillingTypeFacetDetails
};
